// Kart numarası gösterim yardımcıları.
// Numara veritabanında/serviste her zaman birleşik (boşluksuz) tutulur;
// boşluklar yalnızca ekranda gösterim için eklenir.

// Kart numarasını 4'erli gruplara ayırır. Maskeli değerler (4543 14** ****) de
// desteklenir: mevcut boşluklar temizlenip yeniden gruplanır. Rakam ve maske
// karakteri (*, X, •) dışında bir şey içeren değerler olduğu gibi döner.
export function formatCardNumberGroups(value?: string | null): string {
  if (!value) return ''

  const compact = `${value}`.replace(/\s+/g, '')
  if (!/^[\d*Xx•]+$/.test(compact)) return `${value}`

  return (compact.match(/.{1,4}/g) || [compact]).join(' ')
}

// Ekrandan gelen boşluklu değeri servise gidecek birleşik hâline çevirir.
export function compactCardNumber(value?: string | null): string {
  if (!value) return ''

  return `${value}`.replace(/\D/g, '')
}
